type TrueOrUndefined = true | undefined;
type BooleanOrUndefined = boolean | undefined;

export function trueOrUndefined(prop: BooleanOrUndefined): TrueOrUndefined {
  return Boolean(prop) || undefined;
}
